export default __webpack_public_path__ + "static/media/pfizer.89a2de31.svg";